import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { textLG } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const StickyNavOffice = styled.div`
  position: sticky;
  display: flex;
  align-items: center;
  top: ${({ top }) => top ?? 0}px;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.35s;
  background-color: ${COLORS.white};
  box-shadow: 3px 3px 8px 0px rgba(112, 112, 112, 0.13);
  min-height: 120px;

  ${({ active }) =>
    active &&
    css`
      position: sticky;
      opacity: 1;
      z-index: 999;
    `}

  @media ${DEVICES.tablet} {
    display: none;
  }
`

export const Office = styled.div`
  border-right: 1px solid ${COLORS.grey[10]};
  padding: 24px 42px;
  display: flex;
  align-items: center;
  max-width: 40%;

  img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 20px;
  }
`

export const OfficeInfo = styled.div`
  color: ${COLORS.secondary};
  overflow: hidden;
`

export const OfficeInfoName = styled.h4`
  ${textLG};
  margin-bottom: 2px;
  letter-spacing: 1.2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const OfficeInfoAddress = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StickyNavOfficeActions = styled.div`
  flex: 1;
  padding: 24px 42px;
  display: flex;
  align-items: center;

  > div > button,
  > div > a {
    margin-right: 10px;
  }

  .share-button {
    margin-left: auto;

    div {
      margin-right: 0;
    }
  }
`
